import { css } from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const STAT_INK_DARK = {
  timeSpent: '#f45ba5',
  lessons: '#a278f0',
  xp: '#accc51'
} as const;

export const myProgressTokens = css`
  --mp-surface: rgba(30, 35, 66, 0.8);
  --mp-surface-muted: rgba(30, 35, 66, 0.6);
  --mp-surface-dim: rgba(30, 35, 66, 0.3);
  --mp-surface-solid: #1e2342;
  --mp-surface-deep: #020b2a;
  --mp-surface-deep-hover: #0a1340;
  ${onLightTheme`
    --mp-surface-muted: rgba(30, 35, 66, 0.62);
  `}

  --mp-border: rgba(255, 255, 255, 0.15);
  --mp-track: rgba(255, 255, 255, 0.1);
  --mp-track-edge: rgba(255, 255, 255, 0.34);

  --mp-text: #fbfcff;
  --mp-text-strong: var(--color-white);
  --mp-text-muted: rgba(255, 255, 255, 0.7);
  --mp-text-dim: rgba(255, 255, 255, 0.5);
  --mp-text-faint: rgba(255, 255, 255, 0.34);

  --mp-ink-note: var(--mp-text-dim);
  --mp-ink-note-strong: var(--mp-text-dim);
  --mp-ink-note-page: var(--mp-text-dim);
  --mp-ink-mark: var(--mp-text-faint);
  --mp-edge-card: var(--mp-track-edge);
  --mp-edge-page: var(--mp-track-edge);
  --mp-ink-chip: var(--mp-text-muted);
  --mp-surface-lift: var(--mp-surface-dim);
  ${onLightTheme`
    --ln-podium-rank-ink: var(--mp-text-strong);
    --mp-ink-note: var(--mp-text-muted);
    --mp-ink-note-strong: var(--mp-text-strong);
    --mp-ink-note-page: rgb(var(--ln-content) / 0.7);
    --mp-ink-mark: var(--mp-text-dim);
    --mp-edge-card: var(--mp-text-dim);
    --mp-edge-page: rgb(var(--ln-content) / 0.7);
    --mp-ink-chip: var(--mp-text-strong);
    --mp-surface-lift: var(--mp-surface-solid);
  `}

  --mp-accent: #06b6d4;
  --mp-accent-strong: #13b6e8;
  --mp-focus-ring: var(--mp-accent);
  ${onLightTheme`
    --mp-accent: #3dcfed;
    --mp-accent-strong: #3cccff;
  `}

  --mp-accent-on-page: #06b6d4;
  --mp-accent-strong-on-page: #13b6e8;
  ${onLightTheme`
    --mp-accent-on-page: #00718e;
    --mp-accent-strong-on-page: #006e9c;
  `}
  --mp-shadow-card: 0 4px 12px rgba(0, 0, 0, 0.3);

  --mp-stat-timespent-ink: ${STAT_INK_DARK.timeSpent};
  --mp-stat-lessons-ink: ${STAT_INK_DARK.lessons};
  --mp-stat-xp-ink: ${STAT_INK_DARK.xp};
  ${onLightTheme`
    --mp-stat-timespent-ink: #ffa0e7;
    --mp-stat-lessons-ink: #d9b1ff;
  `}
`;

export const STAT_COLORS = {
  timeSpent: {
    color: STAT_INK_DARK.timeSpent,
    ink: 'var(--mp-stat-timespent-ink)',
    gradientFrom: '#BF176D',
    gradientTo: '#F752A4'
  },
  lessons: {
    color: STAT_INK_DARK.lessons,
    ink: 'var(--mp-stat-lessons-ink)',
    gradientFrom: '#5925BC',
    gradientTo: '#8C57F0'
  },
  xp: {
    color: STAT_INK_DARK.xp,
    ink: 'var(--mp-stat-xp-ink)',
    gradientFrom: '#0C9443',
    gradientTo: '#BBD153'
  }
} as const;
